import { render, staticRenderFns } from "./PortionsSubportions.vue?vue&type=template&id=e4f4dec2&scoped=true&"
var script = {}
import style0 from "./PortionsSubportions.vue?vue&type=style&index=0&id=e4f4dec2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f4dec2",
  null
  
)

export default component.exports